interface ICareerTeammates {
  name: string;
  description: string;
  img: string;
}

export const careerTeammates: ICareerTeammates[] = [
  {
    name: 'Kirsten Flores',
    description: 'It is entirely different than the tech corporate life of my previous job. Everyone is super chill, laid back. I feel like I can really be myself when I am at FightCamp.',
    img: 'v4/fc-kirsten-headshot-001.jpg',
  },
  {
    name: 'Alexandre Lapointe',
    description: 'Being able to learn so many technologies and see how they interact with each other within the tech stack is my favorite part of the day. We receive requirements for new projects and we select the best solutions. We have a lot of engineering freedom.',
    img: 'v4/fc-turbo-headshot-001.jpg',
  },
  {
    name: 'Kevin Valade',
    description: 'Many companies promise you growth paths but never follow through — in speaking with FightCamp during the interview process, I found them to be the complete opposite. It was clear to me that they all cared about the people, not just the product.',
    img: 'v4/fc-kevin-headshot-001.jpg',
  },
];
